import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private tokenSubject = new BehaviorSubject<string | null>(
    localStorage.getItem('token')
  );
  token$ = this.tokenSubject.asObservable();
  constructor(private _HttpClient: HttpClient, private _Route: Router) {}

  user_login(person: any): Observable<any> {
    return this._HttpClient.post(`${environment.Server_URL}/login`, person);
  }

  setToken(token: string): void {
    localStorage.setItem('token', token);
    this.tokenSubject.next(token);
  }
  getToken(): string | null {
    return localStorage.getItem('token');
  }

  // logout() {
  //   localStorage.clear();
  //   this._Route.navigate(['/Home']);
  //   console.log('loged out');
  // }
}
